module.exports = __webpack_public_path__ + "static/media/Calendar-selected.4721e8ed.svg";